<template>
  <div>
    <h1 class="title">Presentaci il tuo amico peloso</h1>

    <p class="subtitle">
      Dacci alcune informazioni per aiutare i nostri veterinari a creare la
      pappa giusta per il tuo pelosone!
    </p>

    <form class="form" @submit.prevent>
      <div class="form-group flex items-end">
        <label class="form-label w-full md:w-1/2" for="dog_name"
          >Il mio cane si chiama</label
        >
        <input
          v-model="$v.dog.name.$model"
          type="text"
          placeholder="Inserisci il nome del cane"
          class="form-control w-full md:w-1/2"
          id="dog_name"
        />
        <div v-if="!$v.dog.name.alpha" class="error">
          utilizzare solo lettere per il nome
        </div>
        <div v-else-if="$v.dog.name.$error" class="error">
          campo obbligatorio
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">{{ dogData.name | capitalize }} è</label>

        <div
          class="switch-container"
          :class="[dog.sex == null ? 'switch-empty' : '']"
        >
          <label
            for="sex_male"
            class="switch-option"
            :class="[dog.sex == 1 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.sex.$model"
              class="hidden"
              type="radio"
              id="sex_male"
              value="1"
            />
            <span>Maschio</span>
          </label>
          <label
            for="sex_female"
            class="switch-option"
            :class="[dog.sex == 2 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.sex.$model"
              class="hidden"
              type="radio"
              id="sex_female"
              value="2"
            />
            <span>Femmina</span>
          </label>
        </div>
        <div v-if="$v.dog.sex.$error" class="error">campo obbligatorio</div>
      </div>

      <div v-if="dog.sex != null">
        <div class="form-group">
          <label class="form-label"
            >{{ dogData.name | capitalize }} è
            {{ dog.sex == 1 ? "castrato" : "sterilizzata" }}?</label
          >
          <div
            class="switch-container"
            :class="[dog.neutering == null ? 'switch-empty' : '']"
          >
            <label
              for="neutering_yes"
              class="switch-option"
              :class="[
                dog.neutering == 0.8 ? 'active-option' : 'inactive-option',
              ]"
            >
              <input
                v-model.number="$v.dog.neutering.$model"
                class="hidden"
                type="radio"
                id="neutering_yes"
                value="0.8"
              />
              <span>Sì</span></label
            >
            <label
              for="neutering_no"
              class="switch-option"
              :class="[
                dog.neutering == 1 ? 'active-option' : 'inactive-option',
              ]"
            >
              <input
                v-model.number="$v.dog.neutering.$model"
                class="hidden"
                type="radio"
                id="neutering_no"
                value="1.0"
              />
              <span>No</span></label
            >
          </div>
          <div v-if="$v.dog.neutering.$error" class="error">
            campo obbligatorio
          </div>
          <div class="additional-info">
            Lo sapevi che i cani sterilizzati hanno bisogno di meno calorie
            giornaliere?<br />
            <!-- Aiutaci a {{ dog.sex == 1 ? "conoscerlo" : "conoscerla" }} meglio per
            costruire il perfetto piano alimentare! -->
          </div>
        </div>

        <div class="form-group">
          <label class="form-label"
            >Di quale razza è {{ dogData.name | capitalize }}?</label
          >
          <select class="form-control" v-model.number="$v.dog.breedId.$model">
            <option :value="null" disabled>Seleziona la razza</option>
            <option
              v-for="breed in breeds"
              v-bind:value="breed.id"
              :key="breed.id"
              >{{ breed.name }}</option
            >
          </select>
          <div v-if="$v.dog.breedId.$error" class="error">
            campo obbligatorio
          </div>

          <div class="additional-info">
            Ci siamo ora si entra nel sodo della questione!
          </div>
        </div>

        <div v-show="showMixedBreeds">
          <div class="form-group">
            <select
              class="form-control"
              v-model.number="$v.dog.breedIdFather.$model"
            >
              <option :value="null" disabled
                >Seleziona la razza del papà di
                {{ dogData.name | capitalize }}</option
              >
              <option
                v-for="breed in parentBreeds"
                v-bind:value="breed.id"
                :key="breed.id"
                >{{ breed.name }}</option
              >
            </select>
          </div>

          <div class="form-group">
            <select
              class="form-control"
              v-model.number="$v.dog.breedIdMother.$model"
            >
              <option :value="null" disabled
                >Seleziona la razza della mamma di
                {{ dogData.name | capitalize }}</option
              >
              <option
                v-for="breed in parentBreeds"
                v-bind:value="breed.id"
                :key="breed.id"
                >{{ breed.name }}</option
              >
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";
  import { customValidators } from "../constants.js";

  export default {
    props: {
      wizardData: {
        type: Object,
        required: true,
      },
      dogData: {
        type: Object,
        required: true,
      },
      listData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showMixedBreeds: false,
        dog: {
          name: null,
          sex: null,
          neutering: null,
          breedId: null,
          breedIdFather: null,
          breedIdMother: null,
        },
        breeds: [],
        parentBreeds: [],
      };
    },
    watch: {
      "dog.breedId": "isMixedBreed",
    },
    validations: {
      dog: {
        name: {
          required,
          alpha: customValidators.alpha,
        },
        sex: {
          required,
        },
        neutering: {
          required,
        },
        breedId: {
          required,
        },
        breedIdFather: {
          required: false,
        },
        breedIdMother: {
          required: false,
        },
      },
    },
    methods: {
      getBreeds() {
        this.breeds = this.listData.breeds;
        this.parentBreeds = this.breeds.filter(
          (breed) => breed.slug != "_incrocio"
        );
      },
      submit() {
        this.$v.$touch();
        return new Promise((resolve, reject) => {
          if (!this.$v.$invalid) {
            resolve({
              dog: {
                name: this.dog.name,
                sex: this.dog.sex,
                neutering: this.dog.neutering,
                breedId: this.dog.breedId,
                breedIdFather: this.dog.breedIdFather,
                breedIdMother: this.dog.breedIdMother,
              },
            });
          } else {
            reject("invalid entry");
          }
        });
      },
      isMixedBreed() {
        if (this.dog.breedId == null || this.breeds.length == 0) return;

        var breed = this.breeds.filter(
          (breed) => breed.id == this.dog.breedId
        )[0];

        if (breed["slug"] == "_incrocio") {
          this.showMixedBreeds = true;
        } else {
          this.showMixedBreeds = false;
          this.dog.breedIdFather = null;
          this.dog.breedIdMother = null;
        }
      },
    },
    created() {
      this.getBreeds();
    },
    activated() {
      this.getBreeds();
      this.dog.name = this.dogData.name;
      this.dog.sex = this.dogData.sex;
      this.dog.neutering = this.dogData.neutering;
      this.dog.breedId = this.dogData.breedId;
      this.dog.breedIdFather = this.dogData.breedIdFather;
      this.dog.breedIdMother = this.dogData.breedIdMother;
      if (this.dog.breedIdFather != null || this.dog.breedIdFather != null) {
        this.showMixedBreeds = true;
      } else this.showMixedBreeds = false;
      this.$v.$reset();
    },
  };
</script>
